import { render, staticRenderFns } from "./WhitelabelImage.vue?vue&type=template&id=b7aaea9c&scoped=true&"
import script from "./WhitelabelImage.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelImage.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelImage.vue?vue&type=style&index=0&id=b7aaea9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7aaea9c",
  null
  
)

export default component.exports